import styles from './offer-dialog.module.css'

export const offerInputBtc = (sats: number) => (sats / 1e8).toFixed(8).replace(/\.?0+$/, '')
export const validReferencePrice = (sats?: number | null): sats is number =>
	sats != null && Number.isSafeInteger(sats) && sats > 0

/** Shared by item, collection and trait offers. Discounts always use the reference price. */
export default function OfferPriceShortcuts({
	sats,
	label,
	value,
	onChange
}: {
	sats?: number | null
	label: 'List price' | 'Floor price'
	value: string
	onChange: (value: string) => void
}) {
	const discounts = [0, 5, 10, 20]
	const selected =
		validReferencePrice(sats) && value.trim() !== ''
			? discounts.find(
					(discount) => Number(value) === Math.round((sats * (100 - discount)) / 100) / 1e8
			  )
			: undefined
	return (
		<div className={styles.amountPresets} role="group" aria-label="Price shortcuts">
			{discounts.map((discount) => (
				<button
					key={discount}
					type="button"
					aria-pressed={selected === discount}
					disabled={!validReferencePrice(sats)}
					title={
						discount ? `${discount}% below ${label.toLowerCase()}` : `Use ${label.toLowerCase()}`
					}
					onClick={() => {
						if (validReferencePrice(sats))
							onChange(offerInputBtc(Math.round((sats * (100 - discount)) / 100)))
					}}
				>
					{discount ? `−${discount}%` : label}
				</button>
			))}
		</div>
	)
}
